import styled, { css } from 'styled-components';

export const WrapperStyledFuelGridContainer = styled.div`
  ${({ theme }) => css`
    position: relative;

    .grid-container.sc-fuel-grid-container-h {
      align-items: center;
      padding: ${theme.spacing.km6} ${theme.spacing.km2};
      margin: ${theme.spacing.km0}!important;
    }

    &:active,
    &:hover,
    &:focus,
    &:focus-within {
      background: ${theme.color.hover.neutral.weak};
      outline: none;
      cursor: pointer;
    }

    ::after {
      content: '';
      display: block;
      width: calc(100% + 48px);
      height: 1px;
      background: ${theme.color.border.neutral.default};
      position: absolute;
      bottom: 0px;
      left: -24px;
    }
    :last-child {
      margin-bottom: ${theme.spacing.km5};
      ::after {
        content: none;
      }
    }
  `}
`;

export const WrapperButtonEvaluate = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    font-size: inherit;
    font-weight: ${theme.font.weight.bold};
    align-items: center;
  `}
`;
